<hr />
<div class="content">
  <i class="fa fa-empty-set"></i>
  <p>Sin registros</p>
</div>
